import { createContext, useEffect, useReducer } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { saveToken, removeToken } from 'app/helpers/functions/LocalStorageServices';
const initialState = {
  user: null,
  isInitialised: false,
  isAuthenticated: false
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT': {
      const { isAuthenticated, user } = action.payload;
      return { ...state, isAuthenticated, isInitialised: true, user };
    }

    case 'LOGIN': {
      const { user } = action.payload;
      return { ...state, isAuthenticated: true, user };
    }

    case 'LOGOUT': {
      return { ...state, isAuthenticated: false, user: null };
    }

    case 'REGISTER': {
      const { user } = action.payload;

      return { ...state, isAuthenticated: true, user };
    }

    default:
      return state;
  }
};

const AuthContext = createContext({
  ...initialState,
  method: 'JWT',
  login: () => {},
  logout: () => {},
  register: () => {},
  getUserData: () => {}
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const login = async (email, password) => {
    const response = await axios.post('/login', { email, password });
    const { token } = response.data.data;
    saveToken(token);
    
    const { data } = await axios.get('/profile');
    const user = data?.data;

    dispatch({ type: 'LOGIN', payload: { user } });
  };

  const register = async (email, username, password) => {
    const response = await axios.post('/api/auth/register', { email, username, password });
    const { user } = response.data;

    dispatch({ type: 'REGISTER', payload: { user } });
  };

  const logout = () => {
    removeToken();
    dispatch({ type: 'LOGOUT' });
  };

  const getUserData = async () => {
    const { data } = await axios.get('/profile');
    dispatch({ type: 'INIT', payload: { isAuthenticated: true, user: data?.data } });
  }

  useEffect(() => {
    if(location.pathname.includes('forgot-password')) return;
    if(location.pathname.includes('verify')) return;
    if(location.pathname.includes('reset-password')) return;
    (async () => {
      try {
        const { data } = await axios.get('/profile');
        dispatch({ type: 'INIT', payload: { isAuthenticated: true, user: data?.data } });
      } catch (err) {
        dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
      }
    })();
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, method: 'JWT', login, logout, register, getUserData }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
